import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './custom_modules/SimpleAlertWall/index.css';
import 'react-image-lightbox/style.css';
import App from '../src/App.js';
import * as serviceWorker from './serviceWorker.js';
import "core-js";
import "regenerator-runtime/runtime.js";

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
